import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight } from "lucide-react";

const variants = {
  enter: (dir) => ({ x: dir > 0 ? "100%" : "-100%", opacity: 0.4 }),
  center: { x: 0, opacity: 1 },
  exit: (dir) => ({ x: dir > 0 ? "-100%" : "100%", opacity: 0.4 }),
};

export const Gallery = ({ images, name, testid }) => {
  const [[index, dir], setState] = useState([0, 0]);

  const paginate = (newDir) => {
    setState(([i]) => {
      let next = i + newDir;
      if (next < 0) next = images.length - 1;
      if (next >= images.length) next = 0;
      return [next, newDir];
    });
  };

  const goTo = (i) => setState([i, i > index ? 1 : -1]);

  return (
    <div className="relative w-full" data-testid={testid}>
      <div className="relative w-full aspect-[4/3] md:aspect-[16/10] overflow-hidden bg-brand-sand">
        <AnimatePresence initial={false} custom={dir} mode="popLayout">
          <motion.img
            key={index}
            src={images[index]}
            custom={dir}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ x: { duration: 0.5, ease: [0.22, 1, 0.36, 1] }, opacity: { duration: 0.3 } }}
            className="absolute inset-0 w-full h-full object-cover"
            alt={`${name} - foto ${index + 1}`}
            data-testid={`${testid}-image`}
          />
        </AnimatePresence>

        {/* Arrows */}
        <button
          onClick={() => paginate(-1)}
          aria-label="Foto anterior"
          data-testid={`${testid}-prev`}
          className="absolute left-4 top-1/2 -translate-y-1/2 z-10 w-11 h-11 flex items-center justify-center bg-brand-cream/85 text-brand-forest hover:bg-brand-forest hover:text-brand-cream transition-colors duration-300"
        >
          <ChevronLeft className="w-5 h-5" />
        </button>
        <button
          onClick={() => paginate(1)}
          aria-label="Próxima foto"
          data-testid={`${testid}-next`}
          className="absolute right-4 top-1/2 -translate-y-1/2 z-10 w-11 h-11 flex items-center justify-center bg-brand-cream/85 text-brand-forest hover:bg-brand-forest hover:text-brand-cream transition-colors duration-300"
        >
          <ChevronRight className="w-5 h-5" />
        </button>

        {/* Counter */}
        <div className="absolute bottom-4 right-4 z-10 bg-brand-forest/90 text-brand-cream text-xs font-bold tracking-[0.15em] px-3 py-1.5">
          {String(index + 1).padStart(2, "0")} / {String(images.length).padStart(2, "0")}
        </div>
      </div>

      {/* Thumbnails */}
      <div className="flex gap-2 mt-3 overflow-x-auto pb-1">
        {images.map((img, i) => (
          <button
            key={i}
            onClick={() => goTo(i)}
            aria-label={`Ver foto ${i + 1}`}
            className={`relative flex-shrink-0 w-16 h-14 md:w-20 md:h-16 overflow-hidden transition-opacity duration-300 ${
              i === index ? "ring-2 ring-brand-terracotta opacity-100" : "opacity-55 hover:opacity-90"
            }`}
          >
            <img src={img} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>
    </div>
  );
};
